import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto py-32 px-6 text-center" data-testid="notfound-page">
      <div className="overline">Trail not found</div>
      <h1 className="mt-4 font-heading text-5xl">404</h1>
      <p className="mt-4 text-[color:var(--azsam-ink-soft)]">The page you were looking for wandered off into the desert.</p>
      <Link to="/" className="btn-primary mt-8" data-testid="notfound-home">Return home</Link>
    </div>
  );
}
